import { Avatar, Box, Button, Paper, Stack, type SxProps } from "@mui/material";
import Menu from "@mui/icons-material/Menu";
import { Grid } from "@mui/system";
import { resetFunnelDataInLocalStorage } from "../../utils/LocalStorageManager";
import React from "react";

const Header: React.FC = () => {
    const paperStyle: SxProps = {
        display: "flex",
        py: 1,
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: "white",
        boxShadow: "0px 3px 5px rgba(0,0,0,0.1)",
    };

    const logoStyle: SxProps = {
        width: 164,
        height: 60,
    };

    const calcButtonStyle: SxProps = {
        borderRadius: 37.94,
        py: 2,
        borderColor: "#095bff",
        color: "#00031f",
        fontSize: 18,
        fontFamily: '"Inter", sans-serif',
        display: { xs: "none", sm: "flex" }
    };

    const iconButtonStyle: SxProps = {
        width: 54,
        height: 54,
    };

    const menuStyle: SxProps = { color: "white" };

    const handleOnClick = (e: React.MouseEvent<HTMLButtonElement | HTMLImageElement>) => {
        e.preventDefault();
        resetFunnelDataInLocalStorage();
        window.location.reload();
    };

    return (
        <Paper elevation={1} sx={paperStyle}>
            <Grid container spacing={2} sx={{ flexGrow: 1, px: { xs: 2, md: 6, xl: 12 } }}>
                <Grid size={'grow'}>
                    <Box component="img"
                         src="/logo.svg"
                         alt="Logo adrex dunkel"
                         sx={logoStyle}
                         onClick={handleOnClick} />
                </Grid>
                <Grid offset={'auto'} size={3}>
                    <Stack direction="row" spacing={2} alignItems="center">
                        <Button variant="outlined" sx={calcButtonStyle} fullWidth onClick={handleOnClick}>
                            Jetzt berechnen
                        </Button>

                        <Avatar sx={iconButtonStyle}>
                            <Menu sx={menuStyle} />
                        </Avatar>
                    </Stack>
                </Grid>
            </Grid>
        </Paper>
    );
};

export default Header;
